import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'projects/risd-comp2-copy.png' satisfies MediaPath
const vela = 'portfolio/systema39.png' satisfies MediaPath
const slate = 'portfolio/systema61.png' satisfies MediaPath
const lyra = 'portfolio/IMG_0270.jpg' satisfies MediaPath
const hands = 'portfolio/hands.png' satisfies MediaPath
const creative = 'portfolio/gen-des-sample.jpg' satisfies MediaPath
const dna = 'portfolio/generat-sample-zoom.jpg' satisfies MediaPath
const dissection = 'portfolio/first_lab_dissection.png' satisfies MediaPath
const picasso = 'projects/picasso-project.png' satisfies MediaPath

export const meta: EntryMeta = {
	slug: 'systema',
	name: 'Systema',
	excerpt: 'An exploration of generative graphic design',
	tags: ['generative', 'design', 'code'],
	cover,
	featured: true,
	order: 40,
	repo: 'https://github.com/eam/systema',
}

export default function Systema() {
	return (
		<>
			<h2 className="font-bold text-xl mt-0">Overview</h2>
			<p>
				Systema is a set of parametric layout rules that compose type and form on a grid, then
				perturb it. Each plate is a single seed run through the same generator.
			</p>
			<h2 className="font-bold text-xl">Process</h2>
			<p>
				Built in TypeScript on a canvas pipeline; outputs are exported as high-resolution rasters
				and silkscreened. The source and a live generator are linked above.
			</p>
			<Gallery
				cols={2}
				items={[
					{ src: vela, alt: 'Vela — perturbed display type' },
					{ src: slate, alt: 'Chalk dust on slate' },
					{ src: lyra, alt: 'Lyra — line-field lettering' },
					{ src: hands, alt: 'Hands — particle study' },
					{ src: creative, alt: 'Generative display type' },
					{ src: dna, alt: 'Typographic DNA — print study' },
					{ src: dissection, alt: 'Dithered portrait study' },
					{ src: picasso, alt: 'Form study' },
				]}
			/>
		</>
	)
}
